import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MetroProvider } from './context/MetroContext'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <MetroProvider>
        <App />
      </MetroProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
